import * as React from 'react';
import { Title, Box, ConfirmationModalContent } from '@zen-common/components-base';
import { numberUtils } from '@zen/common-utils';
import {
  NamingAssetStore,
  NamingUtils,
  PasswordRequiredModalContent,
  TechnicalData as TD,
} from '@zen/common-app-parts';
import { DexExecutionStore } from '@zen-dex/utils';
import usePreventAction from '../../../utils/usePreventAction';
import Pair from '../../../components/Pair';

export default function CancelModalProcess({ order, onCancel, onSuccess, onError }) {
  /** @type {[status: ('confirm'|'password'), setStatus: React.SetStateAction<string>]} */
  const [status, setStatus] = React.useState('confirm');
  const { preventAction } = usePreventAction();
  const executionStore = DexExecutionStore.useStore();

  const { state: naming } = NamingAssetStore.useStore();

  const handleConfirmationCancel = () => {
    onCancel();
  };
  const handleConfirmationContinue = () => {
    setStatus('password');
  };

  const handlePasswordBack = () => {
    setStatus('confirm');
  };
  const handlePasswordContinue = async (password) => {
    if (preventAction()) return;

    try {
      await executionStore.actions.cancelOrder({ order, password });
      onSuccess();
    } catch (error) {
      onError(error);
    }
  };

  if (status === 'confirm') {
    return (
      <ConfirmationModalContent
        onCancel={handleConfirmationCancel}
        onConfirm={handleConfirmationContinue}
        confirmText="Continue"
        title={<Title>Cancel Order</Title>}
        subtitle="Are you sure you would like to cancel the order?"
      >
        <Box>
          <Pair
            base={order.makeProps.base}
            quote={order.makeProps.quote}
            copy={false}
            link={false}
            naming={naming}
          />
          <Box>
            <Box>
              <TD.Label>Price per unit: </TD.Label>
              <TD.Value>{numberUtils.toDisplay(order.makeProps.price)}</TD.Value>
            </Box>
            <Box>
              <TD.Label>
                Quantity{' '}
                {order.makeProps.base
                  ? ' - ' + NamingUtils.displayName(order.makeProps.base, naming)
                  : ''}
                :{' '}
              </TD.Label>
              <TD.Value>{numberUtils.toDisplay(order.makeProps.quantity)}</TD.Value>
            </Box>
            <Box>
              <TD.Label>
                Total{' '}
                {order.makeProps.quote
                  ? ' - ' + NamingUtils.displayName(order.makeProps.quote, naming)
                  : ''}
                :{' '}
              </TD.Label>
              <TD.Value>{numberUtils.toDisplay(order.makeProps.total)}</TD.Value>
            </Box>
          </Box>
        </Box>
      </ConfirmationModalContent>
    );
  }

  if (status === 'password') {
    return (
      <PasswordRequiredModalContent
        cancelText="Back"
        submitText="Cancel Order"
        onCancel={handlePasswordBack}
        onSuccess={handlePasswordContinue}
      />
    );
  }

  return null;
}
